import React, {useState} from 'react';

import {Input} from 'views/FormElements';
import {Button} from 'views/AppElements';
import Select from "react-select";


const AVAILABLE_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'A1', 'A2', 'A3', 'A4', 'A5', 'NA']; 

const ReadOnlySizeInput = ({selectedSize, selectedLabel, onRemoveSize}) => {
    const onCancel = (event) => {
        event.preventDefault();
        onRemoveSize(selectedSize);
    }

    return <div className="flexRow readOnlyProductSize">
        <div>{selectedSize}</div>
        <input type="text" value={selectedLabel} readOnly={true} />
        <Button mui="true" onClick={onCancel}>X</Button>
    </div>

};

const EditableSizeInput = ({sizeOptions, onSetSize}) => {
    const [selectedSize, setSelectedSize] = useState('');
    const [sizeLabel, setSizeLabel] = useState('');
    
    const onOK = (event) => {
        event.preventDefault();
        onSetSize(selectedSize, sizeLabel);
        setSelectedSize('');
        setSizeLabel('');
    };

    
    return <div>
            <div className="flexRow editProductSize">
                <div className="flexColumn selectSizeInput">
                    <label>Select Size:</label>
                    <Select value={selectedSize} options={sizeOptions} 
                                                style={{flexGrow: '1', minWidth: '50%'}} 
                                                onChange={(opt) => {
                                                    if(opt)
                                                        setSelectedSize(opt.value);
                                                }} />
                </div>

                <Input name="sizeLabel" className='sizeLabelInput' type="text" value={sizeLabel} label="Enter Label: " placeholder='Eg. Medium (12" x 14")'
                        onChange={(event) => {
                            setSizeLabel(event.target.value);
                        }}/>
                
                <Button mui="true" style={{marginRight:' 10px'}} onClick={onOK}><i className="fa fa-check" aria-hidden="true"></i></Button>
            </div>
            
        </div>
};

const ProductSizeInput = ({values, setFieldValue}) => {
    const sizes = values.productSizes? values.productSizes: {};
    const sizeKeys = Object.keys(sizes);
    const sizeOptions = AVAILABLE_SIZES.filter(s => sizeKeys.indexOf(s) < 0).map(s => {return {label: s, value: s}});

    const onRemoveSize = (size) => {
        const sizesClone = Object.assign({}, sizes);
        delete sizesClone[size];
        setFieldValue('productSizes', Object.keys(sizesClone).length === 0? '': sizesClone);
    };

    const onSetSize = (selectedSize, sizeLabel) => {
        const sizesClone = Object.assign({}, sizes);
        sizesClone[selectedSize] = {label: sizeLabel, shortLabel: selectedSize, priceAddition: 0.0};
        setFieldValue('productSizes', sizesClone);
    }

    const selectedSizes = sizeKeys.map(k => {
        const s = sizes[k];
        return <ReadOnlySizeInput key={"readonlyInput-"+k} onRemoveSize={onRemoveSize} selectedSize={k} selectedLabel={s.label}/>
    });

    return <div id="productSizeInput">
            <label>Artwork Size: </label>
            <EditableSizeInput sizeOptions={sizeOptions} onSetSize={onSetSize} />
            <Input type="hidden" mui="off" name="productSizes" />

            {selectedSizes}
    </div>
};

export default ProductSizeInput;


// WEBPACK FOOTER //
// ./src/views/designer/ProductSizeInput.js